import { useState } from 'react';
import { useQuery, useQueryClient, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { StudentBookingErrorResponse } from 'src/api/types';
import {
    getIsValidRebooker,
    IsValidRebookerResponse,
    RebookersEndpoints,
} from 'src/api/rebookersService';

export const useGetIsValidRebooker = (
    config?: UseQueryOptions<IsValidRebookerResponse, AxiosError<StudentBookingErrorResponse>>
) => {
    const [roomCode, setRoomCode] = useState<string>('');
    const queryClient = useQueryClient();

    const query = useQuery<IsValidRebookerResponse, AxiosError<StudentBookingErrorResponse>>({
        ...config,
        enabled: !!roomCode,
        queryKey: [RebookersEndpoints.GetIsValidRebooker, roomCode],
        queryFn: () => getIsValidRebooker(roomCode),
    });

    const fetchByRoomCode = (value: string) => {
        setRoomCode(value);
    };

    const clearCache = () => {
        setRoomCode('');
        queryClient.removeQueries({
            queryKey: [RebookersEndpoints.GetIsValidRebooker],
            exact: true,
        });
    };

    return {
        ...query,
        fetchByRoomCode,
        clearCache,
    };
};
